<template>
  <div class="caseStatistics">
    <Table ref='table' :form="tForm"></Table>
    <div class="top wbg" v-if='$common.AUTH("statis:statistics:lists")'>
      <a-row class="row" :gutter="40">
        <a-col class="flex" :span="5">
          <label>委托类型：</label>
          <a-select placeholder="请选择" class="select" allowClear>
            <a-select-option :value="1">委托代理</a-select-option>
            <a-select-option :value="2">委托管理</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="5" class="flex">
          <label>案件类型：</label>
          <a-select class="select" v-model='form.cause_type' placeholder="请选择" allowClear>
            <!-- <a-select-option :value="0" disabled>调解</a-select-option> -->
            <a-select-option :value="2">调解</a-select-option>
            <a-select-option :value="1">诉讼</a-select-option>
            <a-select-option :value="3" disabled>公证执行</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="7" class="flex">
          <label style="width:85px;text-align: right;">原告：</label>
          <a-select v-model="form.accuser_id" placeholder="请选择" class="select" mode="multiple" :maxTagCount='1'
            :maxTagTextLength='12' @change="ckAcc" allowClear :filter-option="$common.filterOption">
            <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id">{{ item.title
            }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="flex">
          <label>业务来源：</label>
          <a-select v-model="form.team_id" placeholder="请选择" class="select"
            :disabled="teamList.length > 1 && !form.accuser_id">
            <a-select-option value="">全部</a-select-option>
            <a-select-option v-for="item in teamList" :key="item.team.title" :value="item.team_id">{{ item.team.title
            }}</a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row class="row" :gutter="40" style="margin-bottom:0;">
        <a-col :span="5" class="flex">
          <label>管辖法院：</label>
          <a-select v-model="form.court_id" placeholder="请选择" class="select" mode="multiple" :maxTagCount='1'
            :maxTagTextLength='14' @search="handleSearch" :default-active-first-option="false" :show-arrow="false"
            :filter-option="false" :not-found-content="null" allowClear>
            <a-select-option v-for="item in courtList" :key="item.title" :value="item.id">{{ item.title
            }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="5" class="flex">
          <label style="width:85px;text-align: right;">案由：</label>
          <a-select class="select" placeholder="请选择" mode="multiple" :maxTagCount='1' :maxTagTextLength='8' allowClear
            v-model="form.reason_id">
            <a-select-option v-for="(i, index) in cause_reason" :key="index">{{ i.title }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="7" class="flex">
          <label>录入日期：</label>
          <timePick @PickTime="PickTime" ref="timePicker"></timePick>
        </a-col>
        <a-col :span="3" class="flex">
          <label>是否为作废案件：</label>
          <a-select class="select" v-model='form.is_invaild' placeholder="请选择">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="2">是</a-select-option>
            <a-select-option :value="1">否</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="4" class="flex">
          <a-button icon="search" type='primary' style="height:32px;" @click='form.page = 1; query()'>查询</a-button>
          <a-button style="height:32px;margin-left: 20px;" @click='reset'>重置</a-button>
        </a-col>
      </a-row>
    </div>
    <div class="tcon wbg">
      <div class="tableList" v-if='$common.AUTH("statis:statistics:lists")'>
        <div class="table">
          <table>
            <thead>
              <td width="60">序号</td>
              <td width="260">管辖法院</td>
              <td width="80">案件总数</td>
              <td width="280">原告</td>
              <td width="70">债务人数量</td>
              <td width="70">案件数量</td>
              <td width="100" style="text-align:center;">操作</td>
            </thead>
            <tbody>
              <tr v-for='(i, index) in newO.list' :key='index'>
                <td>{{ index + 1 + (10 * (form.page - 1)) }}</td>
                <td>
                  <Normap :tit='i.title'>{{ i.title }}</Normap>
                </td>
                <td>
                  {{ i.cause_count }}</td>
                <td>
                  <p v-for='(j, index) in i.accuser' :key="index">
                    <Normap :tit="j.title"></Normap>
                  </p>
                </td>
                <td>
                  <p v-for='(j, index) in i.accuser' :key="index">
                    {{ j.debtor_count }}
                  </p>
                </td>
                <td>
                  <p v-for='(j, index) in i.accuser' :key="index">
                    {{ j.cause_count }}
                  </p>
                </td>
                <td style="text-align:center;" v-if='$common.AUTH("statis:statistics:lists")'>
                  <a href='javascript:void(0);' @click='see(i)'>查看</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="loadspin"> <a-spin class="spin" tip="加载中" :spinning="Loading" /></div>
        <div class="pages">
          <a-pagination v-model="form.page" show-quick-jumper :total="newO.count" show-less-items :pageSize='10'
            @change='turnpage' :show-total="(total) => `债务人：${newO.debtor_count} 案件数：${newO.cause_count}`" />
        </div>
      </div>
      <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>
  </div>
</template>
<script>
import {
  getCaseStatis
} from "@/server/statis"
import Table from "./table.vue"
import {
  getAccuserAll,
  reasonList
} from '@/server/api'
import {
  getDirectory
} from "@/server/directory"
export default {
  data() {
    return {
      court: '',
      selectedRowKeys: [],
      newO: {
        list: [],
        count: 0,
        cause_count: 0,
        debtor_count: 0,
      },
      tForm: {
        team_id: [],
        accuser_id: [],
        court_id: [],
        reason_id: [],
        is_invaild: '',
        stime: '',
        etime: ''
      },
      form: {
        page: 1,
        limit: 10,
        team_id: [],
        accuser_id: [],
        court_id: [],
        reason_id: [],
        is_invaild: '',
        stime: '',
        cause_type: undefined,
        etime: ''
      },
      courtList: [],
      cause_reason: [],
      accuserList: [],
      time: [],
      data: [],
      endOpen: false,
      Loading: false
    }
  },
  created() {
    this.query()
    getAccuserAll().then((res) => {
      this.accuserList = res.list
    })
    reasonList().then(e => {
      this.cause_reason = e.list
    })
    this.handleSearch()
  },
  computed: {
    teamList() {
      return this.form.accuser_id.length > 1 || this.form.accuser_id.length == 0 ? [] : this.accuserList.find(ele => {
        return ele.id === this.form.accuser_id[0]
      }).team
    }
  },
  components: {
    Table
  },
  methods: {


    handleSearch(val) {
      getDirectory({
        limit: 100,
        title: val
      }).then((res) => {
        this.courtList = res.list
      })
    },
    turnpage(val) {
      this.form.page = val
      this.query()
    },
    ckAcc(val) {
      if (val.length > 1 || val.length == 0) {
        this.form.team_id = ''
      }
    },
    PickTime(e) {
      if ("stime" in e) {
        this.form.stime = e.stime
      } else {
        this.form.etime = e.etime
      }
    },
    see(item) {
      const form = JSON.parse(JSON.stringify(this.form))
      form.court_id = item.id;
      for (let val in form) {
        if (typeof form[val] == 'object') {
          form[val] = form[val].toString()
        }
      }
      delete form.page
      delete form.limit
      this.tForm = form
      setTimeout(e => {
        this.$refs.table.visible = true;
        this.$refs.table.reset();
      }, 500)
    },
    disabledStartDate(stime) {
      const etime = this.form.etime;
      if (!stime || !etime) {
        return false;
      }
      return stime.valueOf() > etime.valueOf();
    },
    disabledEndDate(etime) {
      const stime = this.form.stime;
      if (!etime || !stime) {
        return false;
      }
      return stime.valueOf() >= etime.valueOf();
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
    query() {
      this.Loading = true
      const form = JSON.parse(JSON.stringify(this.form))
      for (let val in form) {
        if (typeof form[val] == 'object') {
          form[val] = form[val].toString()
        }
      }
      getCaseStatis(form).then(res => {
        // console.log(res)
        this.newO = res
        this.Loading = false
      })
    },
    reset() {
      this.form.limit = 10
      this.form.page = 1
      this.form.cause_type = undefined
      this.form.accuser_id = []
      this.form.team_id = ''
      this.form.court_id = []
      this.form.reason_id = []
      this.form.is_invaild = ''
      this.form.stime = ''
      this.form.etime = ''
      this.$refs.timePicker.clearTime()
      this.query()
    }
  },
}
</script>
<style lang="less" scoped>
.loadspin {
  position: absolute;
  top: 53%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.caseStatistics {
  padding-bottom: 50px;
  @import url('@/assets/css/search.less');
}

// .ant-btn {
//   border-color: #1d8bfe;
//   color: #1d8bfe;
// }
.ant-btn-primary {
  color: #ffffff;
  border-color: #1d8bfe;
  background-color: #1d8bfe;
}

.tcon {
  padding: 0 20px;
  min-height: 720px;

  .tableList {
    width: 100%;
    position: relative;

    .table {
      thead {
        td {
          padding-left: 0;

          &:nth-child(1) {
            padding-left: 20px;
          }
        }
      }

      tbody {
        tr:nth-last-child(1) {
          border-bottom: 1px solid #ebebeb;
        }

        td {
          padding: 6px 0;
          height: 60px;

          &:nth-child(1) {
            padding-left: 20px;
          }

          p {
            padding: 10px 10px 10px 0;
            margin: 0;
            border-bottom: 1px solid #ebebeb;

            &:nth-last-child(1) {
              border: 0 none;
            }
          }
        }
      }
    }
  }
}

.pages {
  text-align: right;
  position: relative;
}
</style>
